import { DeviceUUID } from "device-uuid"
import load from "load-script"

import Script from "./script"

export default class Iubenda extends Script {
  constructor(settings) {
    super(settings)
    this.acceptAll = false
    this.settings = settings
    this.jwtName = "galaxynetworkjwt"
    this.jwt = localStorage.getItem(this.jwtName)
    this.paywallSubDialog = document.querySelector(
      "dialog#paywall-subscription"
    )
  }

  async load() {
    // If paywall is enabled, check if there is a "_gnpt" argument in the URL
    if (this.settings.paywall === true) {
      // Retrive UUID from current device
      this.deviceUUID = new DeviceUUID().get()

      const urlParams = new URLSearchParams(window.location.search)
      const iub_cns = urlParams.get("_gn_iub_cns")
      if (iub_cns && iub_cns === "all") {
        this.acceptAll = true
        // Load the main script
        this.#loadScript()
        return
      }

      const gnpt = urlParams.get("_gnpt")
      if (gnpt) {
        // If there is a "_gnpt" argument, set the JWT in localStorage
        this._debugger(
          "iubenda",
          'Parameter "_gnpt" found, set JWT in localStorage'
        )
        let gnptDecoded = atob(gnpt)
        localStorage.setItem(this.jwtName, gnptDecoded)
        this.jwt = gnptDecoded

        // Remove the "_gnpt" argument from the URL
        const url = new URL(window.location.href)
        url.searchParams.delete("_gnpt")
        window.history.replaceState({}, document.title, url.href)
      }
    }
    // If paywall is enabled, check if the user JWT is valid.
    if (this.settings.paywall === true && this.jwt !== null) {
      this.#checkJWT().then((data) => {
        if (!data.valid) {
          this._debugger(
            "iubenda",
            "JWT is not valid, delete stored JWT and load script"
          )
          this.jwt = null
          localStorage.removeItem(this.jwtName)
          this.#loadScript()
        } else {
          this._debugger("iubenda", "JWT is valid, do nothing")
          return
        }
      })
    } else {
      this.#loadScript()
    }
  }

  async #checkJWT() {
    const response = await fetch(galaxyNetworkInserter.verifyJWTUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        jwt: this.jwt,
        uuid: this.deviceUUID,
      }),
    })
    return response.json()
  }

  #loadScript() {
    window._iub = window._iub || []
    window._iub.csConfiguration = {
      ...this.settings.config,
      callback: {
        onReady: this.#onReady.bind(this),
        onPreferenceExpressed: this.#onPreferenceExpressed.bind(this),
      },
    }
    if (this.settings.paywall === true) {
      // Force Iubenda to not apply styles
      window._iub.csConfiguration.banner.applyStyles = false

      load("//cdn.iubenda.com/cs/beta/iubenda_cs.js")
    } else {
      load("//cdn.iubenda.com/cs/iubenda_cs.js")
    }
  }

  #onReady() {
    this._debugger("iubenda", "onReady called")

    const bannerRationale = document.querySelector(".iubenda-cs-rationale")
    const bannerFooter = document.querySelector(".iubenda-cs-footer")
    const advLink = document.querySelector(
      ".iubenda-advertising-preferences-link"
    )

    if (bannerFooter) bannerRationale.append(bannerFooter)

    if (advLink) advLink.innerHTML = "finalità pubblicitarie"

    if (this.settings.paywall === true && this.acceptAll === true) {
      this._debugger(
        "iubenda",
        'Parameter "_gn_iub_cns" found, accept all purposes.'
      )
      window._iub.cs.api.acceptAll()
      // Remove the "_gn_iub_cns" argument from the URL
      const url = new URL(window.location.href)
      url.searchParams.delete("_gn_iub_cns")
      window.history.replaceState({}, document.title, url.href)

      // Remove the JWT from localStorage
      localStorage.removeItem(this.jwtName)

      //Reload the page to remove the banner
      window.location.reload()
    }
  }
  #onPreferenceExpressed() {
    this._debugger("iubenda", "onPreferenceExpressed called")
    const self = this
    __tcfapi("getTCData", 2, async function (tcData) {
      let allTcfPurposesAccepted = Object.keys(tcData.purpose.consents).every(
        function (purposeId) {
          return tcData.purpose.consents[purposeId] === true
        }
      )
      if (allTcfPurposesAccepted && window._iub.cs.api.isConsentGiven()) {
        if (self.settings.paywall === true) {
          // All purposes accepted, remove jwt from local storage
          localStorage.removeItem(self.jwtName)
          document.body.style.overflow = "auto"
          self.paywallSubDialog.close()
        }
        window.dispatchEvent(new CustomEvent("IubendaConsentGiven"))
        self._debugger("iubenda", "IubendaConsentGiven dispatched")
      } else {
        if (self.settings.paywall === true) {
          // Check if JWT is valid, if not, show the dialog.
          self._debugger("iubenda", "Show paywall subscription dialog")
          document.body.style.overflow = "hidden"
          self.paywallSubDialog.showModal()
        }
      }
    })
  }
}
